import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { Subset } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const PROCESSING_POLL_INTERVAL = 3000;

export const useGetSubset = (matterId?: string, subsetId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Subset, ApiError>(
    [QueryEntity.Subset, matterId, subsetId],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}`, fetchConfigGET);
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
      refetchInterval: (data) => (data?.status === 'processing' ? PROCESSING_POLL_INTERVAL : false),
    },
  );
};
